import { JSONSchemaType } from "ajv"
import validateConstant, {
  e入力パターン,
} from "../../../constant/validateConstant"
import util from "../../../ts/util"
import { THinmeiRegisterPostReq, THinmeiUpdatePutReq } from "./THinmei"

export const THinmeiRegisterPostReqSchema: JSONSchemaType<THinmeiRegisterPostReq> =
  {
    type: "object",
    properties: {
      荷主コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.荷主コード,
        title: "荷主コード",
        errorMessage: util.stringErrorMessage("荷主コード", {
          required: true,
          maxLength: validateConstant.LENGTH.荷主コード,
        }),
      },
      品コード: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.品コード,
        // 99999も登録できないようにする
        pattern: "^(?!99999)[a-zA-Z0-9]+$",
        title: "品コード",
        errorMessage: {
          ...util.stringErrorMessage("品コード", {
            required: true,
            maxLength: validateConstant.LENGTH.品コード,
          }),
          pattern:
            "品コードは99999以外の半角英数字のみ入力可能です。99999は汎用コードのため使用できません。",
        },
      },
      品名: {
        type: "string",
        minLength: 1,
        maxLength: validateConstant.LENGTH.一般名称,
        title: "品名",
        errorMessage: util.stringErrorMessage("品名", {
          required: true,
          maxLength: validateConstant.LENGTH.一般名称,
        }),
      },
      品名カナ: {
        type: "string",
        maxLength: validateConstant.LENGTH.一般略称,
        title: "品名カナ",
        nullable: true,
        errorMessage: util.stringErrorMessage("品名カナ", {
          required: false,
          maxLength: validateConstant.LENGTH.一般略称,
        }),
      },
      品名種別区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "品名種別区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("品名種別区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      単位区分コード: {
        type: "string",
        maxLength: validateConstant.LENGTH.汎用区分コード,
        title: "単位区分コード",
        nullable: true,
        errorMessage: util.stringErrorMessage("単位区分コード", {
          required: false,
          maxLength: validateConstant.LENGTH.汎用区分コード,
        }),
      },
      単位重量: {
        type: "number",
        title: "単位重量",
        nullable: true,
        errorMessage: util.stringErrorMessage("単位重量", {
          required: false,
        }),
      },
      単位容積: {
        type: "number",
        title: "単位容積",
        nullable: true,
        errorMessage: util.stringErrorMessage("単位容積", {
          required: false,
        }),
      },
      荷主請求内訳ID: {
        type: "integer",
        title: "荷主請求内訳ID",
        nullable: true,
        errorMessage: util.stringErrorMessage("荷主請求内訳ID", {
          required: false,
        }),
      },
      危険物フラグ: {
        type: "number",
        title: "危険物フラグ",
        enum: [0, 1],
        errorMessage: util.stringErrorMessage("危険物フラグ", {
          required: false,
        }),
      },
      備考: {
        type: "string",
        nullable: true,
        title: "備考",
        errorMessage: util.stringErrorMessage("備考", {
          required: true,
        }),
      },
    },
    required: ["荷主コード", "品コード", "品名"],
    errorMessage: {
      required: util.JsonSchemeRequiredErrorMessages([
        "荷主コード",
        "品コード",
        "品名",
      ]),
    },
  }

export const THinmeiUpdatePutReqSchema: JSONSchemaType<THinmeiUpdatePutReq> = {
  type: "object",
  properties: {
    荷主コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.荷主コード,
      title: "荷主コード",
      errorMessage: util.stringErrorMessage("荷主コード", {
        required: true,
        maxLength: validateConstant.LENGTH.荷主コード,
      }),
    },
    品コード: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.品コード,
      pattern: validateConstant.PATTERN.英数字のみ,
      title: "品コード",
      errorMessage: util.stringErrorMessage("品コード", {
        required: true,
        maxLength: validateConstant.LENGTH.品コード,
        pattern: e入力パターン.英数字のみ,
      }),
    },
    品名: {
      type: "string",
      minLength: 1,
      maxLength: validateConstant.LENGTH.一般名称,
      title: "品名",
      errorMessage: util.stringErrorMessage("品名", {
        required: true,
        maxLength: validateConstant.LENGTH.一般名称,
      }),
    },
    品名カナ: {
      type: "string",
      maxLength: validateConstant.LENGTH.一般略称,
      title: "品名カナ",
      nullable: true,
      errorMessage: util.stringErrorMessage("品名カナ", {
        required: false,
        maxLength: validateConstant.LENGTH.一般略称,
      }),
    },
    品名種別区分コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "品名種別区分コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("品名種別区分コード", {
        required: false,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    単位区分コード: {
      type: "string",
      maxLength: validateConstant.LENGTH.汎用区分コード,
      title: "単位区分コード",
      nullable: true,
      errorMessage: util.stringErrorMessage("単位区分コード", {
        required: false,
        maxLength: validateConstant.LENGTH.汎用区分コード,
      }),
    },
    単位重量: {
      type: "number",
      title: "単位重量",
      nullable: true,
      errorMessage: util.stringErrorMessage("単位重量", {
        required: false,
      }),
    },
    単位容積: {
      type: "number",
      title: "単位容積",
      nullable: true,
      errorMessage: util.stringErrorMessage("単位容積", {
        required: false,
      }),
    },
    荷主請求内訳ID: {
      type: "integer",
      title: "荷主請求内訳ID",
      nullable: true,
      errorMessage: util.stringErrorMessage("荷主請求内訳ID", {
        required: false,
      }),
    },
    危険物フラグ: {
      type: "number",
      title: "危険物フラグ",
      enum: [0, 1],
      errorMessage: util.stringErrorMessage("危険物フラグ", {
        required: false,
      }),
    },
    備考: {
      type: "string",
      nullable: true,
      title: "備考",
      errorMessage: util.stringErrorMessage("備考", {
        required: false,
      }),
    },
    更新日時: {
      type: "string",
      minLength: 1,
      title: "更新日時",
      errorMessage: util.stringErrorMessage("更新日時", {
        required: true,
      }),
    },
  },
  required: ["荷主コード", "品コード", "品名", "更新日時"],
  errorMessage: {
    required: util.JsonSchemeRequiredErrorMessages([
      "荷主コード",
      "品コード",
      "品名",
      "更新日時",
    ]),
  },
}
